(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sd-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sd-delivery-dates')) {
  customElements.define('sd-delivery-dates', class extends HTMLElement {
    connectedCallback() { this.updateDates(); }
    updateDates() {
      const parts = new Intl.DateTimeFormat('en', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part = type => Number(parts.find(p => p.type === type).value);
      const base = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
      const format = offset => {
        const date = new Date(base);
        date.setUTCDate(date.getUTCDate() + offset);
        return new Intl.DateTimeFormat('fr-FR', {timeZone:'UTC',day:'2-digit',month:'2-digit'}).format(date);
      };
      const shipping = Math.max(0, Number(this.dataset.shipping) || 0);
      const min = Math.max(shipping, Number(this.dataset.min) || 0);
      const max = Math.max(min, Number(this.dataset.max) || 0);
      this.querySelector('[data-delivery-date="today"]').textContent = format(0);
      this.querySelector('[data-delivery-date="shipping"]').textContent = format(shipping);
      this.querySelector('[data-delivery-date="arrival"]').textContent = min === max ? format(min) : format(min) + ' – ' + format(max);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
